import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * Named GeoLocationNode children only. No lat/lng, no MapPoint, no full-tree download.
 */
function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:locationId|parentLocationId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

export const discoveryLocationApi = {
  listByParent: (parentLocationId) => {
    const params = {};
    const parent = parentLocationId == null || parentLocationId === '' ? '' : String(parentLocationId);
    if (parent) params.parentLocationId = parent;
    return travelClient.get(travelEndpoints.discoveryLocations, { params, ...snowflakeJson });
  },
  getById: (locationId) => travelClient.get(travelEndpoints.discoveryLocation(locationId), snowflakeJson),
};
